var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevenueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3333",
    "data-name": "Group 3333",
    transform: "translate(-223 -87)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_552",
    "data-name": "Ellipse 552",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(223 87)",
    fill: "#272848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M1.75,32.875a.875.875,0,0,0-1.75,0v9.188A2.187,2.187,0,0,0,2.188,44.25H13.125a.875.875,0,0,0,0-1.75H2.188a.439.439,0,0,1-.437-.437Zm11.118,2.368A.876.876,0,0,0,11.629,34L8.75,36.886l-1.57-1.57a.876.876,0,0,0-1.239,0L2.879,38.379a.876.876,0,1,0,1.239,1.239l2.445-2.442,1.57,1.57a.876.876,0,0,0,1.239,0l3.5-3.5Z",
    transform: "translate(231 63)",
    fill: "#9dcba7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueIcon);
export default __webpack_public_path__ + "static/media/revenueIcon.7f4fbe7225a081eddf9590908a73d5aa.svg";
export { ForwardRef as ReactComponent };